
import React from 'react'
import PropTypes from 'prop-types'
import QueryManager from './Query'
import gql from 'graphql-tag'
import { get } from 'lodash'

const GET_ABM_RESOURCES = gql`query getGroups {
  getGroups {
    results {
      ... on ABMGroup {
        id
        name
        description
        alias
        usersCount
        createdIn
        updatedIn
        createdBy
        rolesAssociated {
          id
          resourcesCount
        }
        permissions {
          id
          name
          accesses
        }
      }
    }
  }
}`

const GetABMResources = ({ children, ...props }) => {
  return (
    <QueryManager query={GET_ABM_RESOURCES} {...props} >
      {({ data, loading, fetchMore, refetch, client }) =>
        children({
          data: get(data, 'getGroups.results', []),
          count: get(data, 'getGroups.count', 0),
          refetch,
          loading,
          client
        })}
    </QueryManager>
  )
}

GetABMResources.propTypes = {
  children: PropTypes.any
}

export default GetABMResources
